import { UseIonAlertResult, useIonAlert } from "@ionic/react";

// Wrapping Ionic's alert hook in case we want to use native Alerts via Capacitor where available.
export default function useAlert(): UseIonAlertResult {
  const [show, hide] = useIonAlert();

  return [show, hide];
}
